module.exports = __webpack_public_path__ + "img/loquats-350x184.37ce8acb.jpg";